module.exports = __webpack_public_path__ + "static/img/PRODUCT CARD_PU SKIN_mobile.18f1f183.jpg";